import { AppProcessingProvider, RelationshipOption } from './ApplicationProcessingProvider';
import { Application } from '~/data/useApplication';
import { ApplicationCardsStateProvider } from './ApplicationCardsStateProvider';
import { ApplicationAdditionalDocumentRequestContextProvider } from './AdditionalDocumentRequestProvider';
import { SchoolCustomizationProvider } from '~/context/SchoolCustomizationsProvider';
import { SchoolCustomizations } from '~/data/useSchoolCustomizations';
import { Course } from '@ab/ams-school-api/types/private/v1';
import { EntityHistoryEntry, EntityHistoryMap } from '~/data/useEntityHistory';
import { EducationHistoryTimestamps } from '~/data/useEducationHistoryTimestamps';

export type { CardSection } from './ApplicationCardsStateProvider';
export type { Process, RelationshipOption } from './ApplicationProcessingProvider';
export { useAppProcessing } from './ApplicationProcessingProvider';
export { useAdditionalDocumentRequest } from './AdditionalDocumentRequestProvider';
export { useApplicationCards, useApplicationCard } from './ApplicationCardsStateProvider';

type ApplicationDetailContextProps = {
  application: Application;
  children: React.ReactNode;
  schoolCustomizations: SchoolCustomizations;
  courses: Course[];
  relationshipOptions: RelationshipOption[];
  entityHistoryMap?: EntityHistoryMap;
  educationHistoryTimestamps?: EducationHistoryTimestamps;
  ehKeyTimestamps?: Record<string, EntityHistoryEntry>;
};
export const ApplicationDetailContext = (props: ApplicationDetailContextProps) => {
  return (
    <AppProcessingProvider
      application={props.application}
      courses={props.courses}
      relationshipOptions={props.relationshipOptions}
      entityHistoryMap={props.entityHistoryMap}
      educationHistoryTimestamps={props.educationHistoryTimestamps}
      ehKeyTimestamps={props.ehKeyTimestamps}
    >
      <SchoolCustomizationProvider schoolCustomizations={props.schoolCustomizations}>
        <ApplicationCardsStateProvider>
          <ApplicationAdditionalDocumentRequestContextProvider>
            {props.children}
          </ApplicationAdditionalDocumentRequestContextProvider>
        </ApplicationCardsStateProvider>
      </SchoolCustomizationProvider>
    </AppProcessingProvider>
  );
};
